import i18next from 'i18next';

import { createAccount } from 'common/api/v1/auth';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    CREATE_ACCOUNT_USER,
    CREATE_ACCOUNT_USER_SUCCESS,
    CREATE_ACCOUNT_USER_FAILURE,
} from '../actionTypes';
import { createAccountActions } from '../reducer';

import autoLogin from './autoLogin';
import resetForm from './resetForm';

export default (values, loadingContext) => (dispatch) => {
    dispatch(createAccountActions[CREATE_ACCOUNT_USER]());
    loadingContext.openLoading(
        i18next.t('Creating your account').concat('...'),
    );

    createAccount(values)
        .then((response) => {
            localStorage.setItem('token', response?.data?.token);
            dispatch(
                createAccountActions[CREATE_ACCOUNT_USER_SUCCESS](
                    response?.data,
                ),
            );
            dispatch(resetForm());
            dispatch(autoLogin(() => loadingContext.closeLoading()));
        })
        .catch((error) => {
            loadingContext.closeLoading();
            dispatch(
                createAccountActions[CREATE_ACCOUNT_USER_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
